module.exports = __webpack_public_path__ + "img/rang5.f9007a2f.png";